<template>
  <div class="edit-product">
    <div class="breadcrumb" style="background: #fff">编辑产品</div>
    <div class="third-title" @click="asd"><span>基本信息</span></div>
    <div class="order-detail-basic" style="padding-top: 0">
      <el-form :model="basicInfo" label-width="170px" ref="formRef">
        <el-form-item label="产品分类:" class="address-ipt">
          <span>{{category}}</span>
        </el-form-item>
        <el-form-item label="产品名称:" prop="spuName">
          <span>{{basicInfo.spuName}}</span>
        </el-form-item>
        <el-form-item label="产品描述:" prop="spuDesc">
          <p>{{basicInfo.spuDesc}}</p>
        </el-form-item>
        <el-form-item label="产品性质:" prop="propertyId">
          <span>{{basicInfo.spuProperty==='CUSTOM'?'定制':basicInfo.spuProperty==='NORMAL'?'通货':'未定义'}}</span>
        </el-form-item>
        <el-form-item label="产品标签:" prop="propertyId" v-if="$route.query.isSeries==='false'">
          <span>{{basicInfo.spuTags}}</span>
        </el-form-item>
        <div v-for="(v,k) in spuComposeAreaList" :key="k">
          <el-form-item :label="$config.pageType[k]+'合成区:'" v-if="$route.query.isSeries==='false'&&basicInfo.spuProperty!=='NORMAL'" :prop="k">
            <span>{{spuComposeAreaList[k].composeArea.areaName}}</span>
            <el-button type="primary" style="margin-left:10px;" v-if="spuComposeAreaList[k].composeArea.id" round
              @click="areaLine=spuComposeAreaList[k].composeArea,dialogVisible = true">查看合成区属性</el-button>
            <el-form-item label="机器码:" label-width="60" v-if="spuComposeAreaList[k].composeArea.leftComposeCode==='MACHINE_CODE'">
              {{spuComposeAreaList[k].machineCodeName}}
            </el-form-item>
          </el-form-item>
        </div>
        <el-form-item v-if="$route.query.propertyName!=='通货'" label="产品分辨率:">
          {{basicInfo.spuDpi}}
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries==='false'" label="已选属性:">
          <div>
            <el-table :data="basicInfo.spuDictList" border style="width: 100%">
              <el-table-column prop="propKey" label="属性" width="150px"></el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries === 'false' && basicInfo.whitePage !== undefined &&$route.query.propertyName!=='通货'" label="白页:">
          <div>
            <el-table :data="[basicInfo.whitePage]" border style="width: 100%">
              <el-table-column prop="whitePageName" label="白页名称" width="200px"></el-table-column>
              <el-table-column prop="date" label="白页出现位置" width="200px">
                <template slot-scope="scope">
                  <p>封面：{{scope.row.whitePageCoverPosition}}</p>
                  <p>内页：{{scope.row.whitePageTextPosition}}</p>
                  <p>单页：{{scope.row.whitePageSimplePosition}}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries==='false' && basicInfo.pageNumber!==undefined &&$route.query.propertyName!=='通货'" label="内页页码:">
          <div>
            <el-table :data="[basicInfo.pageNumber]" border style="width: 100%">
              <el-table-column prop="pageName" label="页码名称" width="200px"></el-table-column>
              <el-table-column prop="startPage" label="页码起始页" width="200px"></el-table-column>
              <el-table-column prop="pageNumber" label="每P页码数" width="200px"></el-table-column>
              <el-table-column prop="date" label="参数" width="200px">
                <template slot-scope="scope">
                  <p v-for="item in scope.row.pageNumberDetailList" :key='item.id'>
                    页码①：<span>距上{{item.pageTop}}mm；</span><span>距右{{item.pageRight}}mm；</span><span>距下{{item.pageBottom}}mm；</span><span>距左{{item.pageLeft}}mm；</span>
                  </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.isSeries==='false'&&$route.query.propertyName!=='通货'" label="能否从尺寸匹配到此产品:">
          {{basicInfo.allowMatchSize?'是':'否'}}
        </el-form-item>
        <el-form-item label="是否隐藏此产品:">
          {{basicInfo.isHidden?'是':'否'}}
        </el-form-item>
        <el-form-item class="noleft-third-title">
          <div class="third-title"><span>产品详情</span></div>
        </el-form-item>
        <el-form-item label="产品图片:">
          <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none">
          <div class="upload_warp_img" v-show="basicInfo.primaryImages.length!==0">
            <div class="upload_warp_img_div" v-for="(item,index) of basicInfo.primaryImages" :key="index">
              <div class="upload_img">
                <img :src="item.url">
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue">下载图片</p>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <p style="color: #999;line-height: 22px;">按住ctrl/shift可同时批量选择多张图片上传，最多可以上传5张图片，建议尺寸800*800px</p>
        </el-form-item>
        <el-form-item label="产品视频:">
          <video style="width:200px" id='video' v-bind:src="basicInfo.spuVideo.url" class="avatar video-avatar" controls="controls">
            您的浏览器不支持视频播放
          </video>
        </el-form-item>
        <el-form-item label="电脑详情:" prop="pcDetail">
          <p v-html="basicInfo.pcDetail" class="pc_detail"></p>
        </el-form-item>
        <el-form-item label="移动端详情:" prop="phoneDetail">
          <p v-html="basicInfo.phoneDetail" class="pc_detail"></p>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="$router.go(-1)">返回</el-button>
    </div>
    <!-- 查看合成区属性 -->
    <el-dialog :close-on-click-modal="false" title="查看合成区属性" :visible.sync="dialogVisible">
      <el-form ref="form" :model="areaLine" label-width="170px" inline>
        <el-form-item label="合成区:" class="address-ipt">
          <div class="area"><span>上：</span> {{ areaLine.areaTop }}mm</div>
          <div class="area"><span>下：</span> {{ areaLine.areaBottom }}mm</div>
          <div class="area"><span>左：</span> {{ areaLine.areaLeft }}mm</div>
          <div class="area"><span>右：</span> {{ areaLine.areaRight }}mm</div>
        </el-form-item>
        <el-form-item label="合成信息位置:">
          {{ $config.barcodePosition[areaLine.barcodePosition] }}
          <el-form-item label="合成信息后是否加码:" label-width="185px">
            {{ areaLine.composeAfterCodeIsAppear?'是':'否' }}
          </el-form-item>
          <el-form-item label="左侧合成码:" label-width="115px" style="margin-left:20px;">
            {{ $config.leftComposeCode[areaLine.leftComposeCode]}}
          </el-form-item>
        </el-form-item>
        <el-form-item label="靠边:">
          {{ areaLine.marginSize+'mm'}}
          <el-form-item label="字号:" label-width="115px" style="margin-left:20px;">
            {{ areaLine.fontSize+'px'}}
          </el-form-item>
        </el-form-item>
        <el-form-item label="合成区任务码:">
          <el-form-item label="宽度:" label-width="55px" style="margin-left:20px;">
            {{ areaLine.jobCodeWidth+'mm'}}
          </el-form-item>
          <el-form-item label="高度:" label-width="55px" style="margin-left:20px;">
            {{ areaLine.jobCodeHeight+'mm'}}
          </el-form-item>
        </el-form-item>
        <el-form-item label="裁切线设置:">
          {{ areaLine.cornerMargin+'mm'}}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import $ from 'jquery'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { addQuillTitle } from '@/assets/js/quill.js'
import { areaList, areaUsable, categoryQuerySub, spuSeriesAdd, spuSeriesUpdate, spuUpdate, areaAdd, spuGet, categoryQuerySubs, categoryList, categoryGet, dictUsable, spuAdd } from '@/api/pms'
export default {
  name: 'edit-product',
  data () {
    return {
      spuComposeAreaList: {},
      awsSdk: null,
      confirmDialog: false,
      dialogVisible: false,
      category: '',
      basicInfo: {
        whitePage: {
          whitePageCoverPosition: '',
          whitePageTextPosition: '',
          whitePageSimplePosition: ''
        },
        pageNumber: {
          pageNumberDetailList: []
        },
        ownCategoryId: '',
        topCategoryId: '',
        subCategoryId: '',
        categoryId: '',
        spuType: 0,
        areaId: '',
        dictIdSet: [],
        pcDetail: '',
        phoneDetail: '',
        primaryImages: [],
        spuProperty: {
          propertyName: ''
        },
        composeArea: {
          id: '',
          areaName: '',
          areaTop: '',
          areaBottom: '',
          areaLeft: '',
          areaRight: '',
          barcodePosition: '',
          createdTime: '',
          deleted: false,
          version: ''
        },
        propertyId: '',
        spuDesc: '',
        spuName: '',
        spuVideo: {
          mimetype: '',
          sortOrder: '',
          url: ''
        }
      },
      arrList: [],
      videoFlag: false, // 是否显示进度条
      videoUploadPercent: '', // 进度条的进度，
      isShowUploadVideo: false, // 显示上传按钮
      rules: {
        ownCategoryId: [{
          required: true,
          message: '请填写产品类别'
        }],
        subCategoryId: [{
          required: true,
          message: '请填写产品类别'
        }],
        categoryId: [{
          required: true,
          message: '请填写产品类别'
        }],
        spuName: [
          {
            required: true,
            message: '请填写产品名称',
            trigger: 'blur'
          }, {
            message: '产品名称不能超过20个字符',
            min: 1,
            max: 20
          }
        ],
        spuDesc: [{
          required: true,
          message: '请填写产品描述'
        }, {
          message: '产品描述不能超过50个字符',
          min: 1,
          max: 50
        }],
        propertyId: [{
          required: true,
          message: '请选择产品性质'
        }],
        areaId: [{
          required: true,
          message: '请选择合成区类型'
        }],
        phoneDetail: [{
          required: true,
          message: '请填写移动端详情'
        }],
        pcDetail: [{
          required: true,
          message: '请填写电脑详情'
        }]
      },
      queryId: '',
      typeFirst: [],
      typeSecond: [],
      typeThird: [],
      typeFourth: [],
      attrList: [],
      areaList: [],
      topBottom: '',
      topSubBottom: '',
      topThirdBottom: '',
      areaLine: {}
    }
  },
  created () {
    this.queryId = this.$route.query.id
    this.getSpuBasiceInfo()
  },
  methods: {
    asd () {
    },
    // 上传产品PC端详情图片
    uploadPcDetailImg (e) {
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.pcQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    backTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    // 获取产品详情
    getSpuBasiceInfo () {
      spuGet(this.$route.query.id).then(res => {
        if (res.data.success) {
          let obj = {}
          obj = res.data.data
          // 处理分类
          let attrList = []
          if (obj.category.subCategory) {
            if (obj.category.subCategory.subCategory) {
              if (obj.category.subCategory.subCategory.subCategory) {
                attrList.push(obj.category.subCategory.subCategory.subCategory.categoryName)
              }
              attrList.push(obj.category.subCategory.subCategory.categoryName)
            }
            attrList.push(obj.category.subCategory.categoryName)
          }
          obj.category.bottom = true
          attrList.push(obj.category.categoryName)
          attrList = attrList.join('>')
          this.category = attrList
          // 处理图片
          obj.primaryImages = []
          obj.spuImageList.forEach((item, index) => {
            obj.primaryImages.push({
              sortOrder: index,
              url: item
            })
          })
          // 处理视频
          obj.spuVideo = {
            sortOrder: 0,
            url: obj.spuVideoUrl
          }
          // 处理合成区
          let spuComposeAreaList = {}
          obj.composeAreaList.forEach(item => {
            spuComposeAreaList[item.pageTypeCode] = {
              composeArea: item,
              machineCodeName: item.leftComposeCode === 'MACHINE_CODE' ? item.spuMachineCode.machineCodeName : ''
            }
          })
          this.spuComposeAreaList = spuComposeAreaList
          this.basicInfo = obj
          this.backTop()
          this.$forceUpdate()
          this.$nextTick(() => {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            window.scrollTo(0, 0)
          })
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
@import "styles";
@deep: ~">>>";
@{deep} .pc_detail {
  width: 100%;
  img {
    width: 100%;
  }
}
.address-list {
  margin-left: 0 !important;
  display: flex;
  .address-ipt2 {
    margin-right: 0 !important;
    margin-left: 0 !important;
    @{deep} .el-form-item__content {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
  @{deep} .address-ipt {
    .el-form-item__content {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
  .el-form-item {
    display: inline-block;
  }
}
</style>
